import {createContext, useContext, useState} from 'react'
import {StorePublicOptions} from '@data/queries/reservations/getReservationsStorePublicOptions.reservations'
import dayjs from 'dayjs'

import {useUserData} from './useUserData.main'

export type ReservationContextType = {
  timezone: string
  storeOptions: StorePublicOptions
  dateDay: Date
  setDateDay: (date: Date) => void
  dateHour: string
  setDateHour: (hour: string) => void
  partySize: number
  setPartySize: (partySize: number) => void
  sectorId: string
  setSectorId: (sectorId: string) => void
  date: Date
  setDate: (date: Date) => void
  specialRequests: string
  setSpecialRequests: (specialRequests: string) => void
  specialOccasion: string
  setSpecialOccasion: (specialOccasion: string) => void
  isWaitingList?: boolean
} & ReturnType<typeof useUserData>

export const ReservationContext = createContext<ReservationContextType>(null)

export function useCreateTheCreateReservationContext(
  storeOptions: StorePublicOptions,
  isWaitingList?: boolean
): ReservationContextType {
  const [dateDay, setDateDay] = useState(dayjs().tz(storeOptions.timezone).startOf('day').toDate())
  const [dateHour, setDateHour] = useState<string>()
  const [partySize, setPartySize] = useState(2)
  const [date, setDate] = useState<Date>()
  const [sectorId, setSectorId] = useState<string>()
  const [specialRequests, setSpecialRequests] = useState<string>()
  const [specialOccasion, setSpecialOccasion] = useState<string>()
  const userData = useUserData()

  return {
    storeOptions,
    dateDay,
    setDateDay,
    dateHour,
    setDateHour,
    partySize,
    setPartySize,
    date,
    setDate,
    sectorId,
    setSectorId,
    specialRequests,
    setSpecialRequests,
    specialOccasion,
    setSpecialOccasion,
    isWaitingList,
    timezone: storeOptions.timezone,
    ...userData
  }
}

export function useCreateReservationContext(): ReservationContextType {
  return useContext(ReservationContext)
}
